export const GET_COUNTRY_TAX_REQUEST = 'GET_COUNTRY_TAX_REQUEST';
export const GET_COUNTRY_TAX_SUCCESS = 'GET_COUNTRY_TAX_SUCCESS';
export const RESET_COUNTRY_TAX = 'RESET_COUNTRY_TAX';
export const SAVE_COUNTRY_NAME = 'SAVE_COUNTRY_NAME';
